import FormTerminateContract from './FormTerminateContract';

export default FormTerminateContract;